import { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
}

export default function FAQItem({ question, answer }: FAQItemProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-background-200">
      <button
        className="w-full flex items-center justify-between py-4 cursor-pointer text-left"
        onClick={() => setOpen(!open)}
      >
        <span className="font-heading text-base text-foreground-900 pr-4">{question}</span>
        <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          open ? 'max-h-96 pb-4' : 'max-h-0'
        }`}
      >
        <p className="text-sm text-foreground-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}